import _styled from "styled-components";
import { getThemeStyle } from "~/features/ui/get-theme-style";
type Props = {
  title: string;
};
export function TableTitle(props: Props & React.ComponentPropsWithRef<"div">) {
  const {
    title,
    ...rest
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  return <_StyledH {...rest} $_css={[{
    "display": "flex",
    "flex": "1 1 0%",
    "flexShrink": "0",
    "alignItems": "center",
    "whiteSpace": "nowrap",
    "borderBottomWidth": "1px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(208 208 218 / var(--tw-bg-opacity))",
    "paddingLeft": "2.4rem",
    "paddingRight": "2.4rem",
    "paddingTop": "0.8rem",
    "paddingBottom": "0.8rem",
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "500",
    "@media (min-width: 1024px)": {
      "minWidth": "400px",
      "borderBottomWidth": "0px",
      "fontSize": "1.4rem",
      "lineHeight": "1.5",
      "letterSpacing": "0.014000000000000002rem",
      "fontWeight": "500"
    }
  }, themeStyle.border]}>
      {title}
    </_StyledH>;
}
var _StyledH = /*#__PURE__*/_styled("h2").withConfig({
  displayName: "table-title___StyledH",
  componentId: "sc-9cx4x-0"
})(["", ""], p => p.$_css);